module.exports = __webpack_public_path__ + "static/media/user.f7f90bb0.svg";